import React, { useState } from "react";
import axios from "axios";
import { useLoader } from "../../context/LoaderContext";
import { dynamicFailed, dynamicSuccess } from "../../hooks/custom/useToast";

const ContactForm = () => {
  const { setLoading } = useLoader();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    textMessage: "",
  });

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/contact`,
        formData,
      );

      if (response.status === 200 || response.status === 201) {
        dynamicSuccess("Submitted successfully!");
        setFormData({
          name: "",
          email: "",
          mobile: "",
          address: "",
          textMessage: "",
        });
      } else {
        dynamicFailed("Submission failed!");
      }
    } catch (err) {
      console.error(err);
      dynamicFailed("Failed to send!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section>
        <div className="td_height_120 td_height_lg_40" />
        <div className="container">
          <div
            className="td_section_heading td_style_1 wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.15s"
          >
            <h2 className="td_section_title td_fs_48 mb-0 td_center">
              Stay Connected with UNepal
            </h2>

            <div className="td_height_30 td_height_lg_30" />

            <p className="td_fs_18 mb-0">
              Be the first to hear about new programs, campus developments,
              events and ways to get involved.
            </p>

            <div className="td_height_30 td_height_lg_30" />

            <div className="td_form_card td_style_1 td_radius_10 td_gray_bg_5 custom_td_form_card">
              <div className="td_form_card_in">
                <h2 className="td_fs_36 td_mb_20 text-uppercase td_mb_16 td_center">
                  Contact Form
                </h2>

                <h3 className="td_fs_20 td_medium td_heading_color td_mb_10">
                  Full Name *
                </h3>
                {/* Name */}
                <div className="td_mb_40">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="td_form_field td_mb_8 td_medium td_white_bg"
                    placeholder="Enter your Full Name"
                  />
                </div>

                {/* Email + Phone same row */}
                <div className="row">
                  <div className="col-lg-6">
                    <h3 className="td_fs_20 td_medium td_heading_color td_mb_10">
                      Email *
                    </h3>
                    <div className="td_mb_40">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="td_form_field td_mb_8 td_medium td_white_bg"
                        placeholder="Enter your Email"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <h3 className="td_fs_20 td_medium td_heading_color td_mb_10">
                      Phone Number *
                    </h3>
                    <div className="td_mb_40">
                      <input
                        type="text"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="td_form_field td_mb_8 td_medium td_white_bg"
                        placeholder="Enter your Phone Number"
                      />
                    </div>
                  </div>
                </div>

                {/* Address */}
                <h3 className="td_fs_20 td_medium td_heading_color td_mb_10">
                  Address *
                </h3>
                <div className="td_mb_40">
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="td_form_field td_mb_8 td_medium td_white_bg"
                    placeholder="Enter your Address"
                  />
                </div>

                {/* Message */}
                <h3 className="td_fs_20 td_medium td_heading_color td_mb_10">
                  Message *
                </h3>
                <div className="td_mb_40">
                  <textarea
                    name="textMessage"
                    value={formData.textMessage}
                    onChange={handleChange}
                    className="td_form_field td_mb_8 td_medium td_white_bg"
                    placeholder="Type your message..."
                    rows={4}
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="row align-items-center td_row_reverse_lg td_gap_y_20 mb-5">
                  {/* <div className="col-lg-6 text-center-lg"></div> */}
                  <div className="col-lg-6">
                    <button
                      onClick={handleSubmit}
                      className="td_btn td_style_1 td_radius_10 td_medium w-25"
                    >
                      <span className="td_btn_in td_white_color td_accent_bg">
                        <span>Send</span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="td_height_120 td_height_lg_40" />
      </section>
    </>
  );
};

export default ContactForm;
